<template>
  <div>
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
};
</script>

<style>
body {
  padding: 0 !important;
  margin: 0;
}
.v-sheet.v-card {
  border-radius: 12px !important;
}
.v-list-item {
  cursor: pointer !important;
}
.h-100vh {
  min-height: 100vh;
}
.form {
  margin: 0 auto;
  width: 90%;
  max-width: 480px;
}
.social-icons .facebook {
  background: #1877f2;
  color: #ffffff;
}
.social-icons .twitter {
  background: #1da1f2;
  color: #ffffff;
}
.social-icons .instagram {
  background: #e4405f;
  color: #ffffff;
}
.social-icons .spotify {
  background: #5bd25e;
  color: #ffffff;
}
.social-icons .apple {
  background: #f7f7f7;
  color: #221e1f;
}
.social-icons .soundcloud {
  background: #ff3300;
  color: #ffffff;
}
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
}
.edit-icon {
  background: rgb(54, 138, 33) !important;
  color: #fff !important;
  font-size: 12px;
}
.delete-icon {
  background: rgb(138, 33, 33) !important;
  color: #fff !important;
  font-size: 12px;
}
.inline-desc {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* Tooltip CSS */
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.overflow-text-hidden * {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.w-100 {
  width: 100%;
}
</style>

<script>
export default {
  async created() {
    if (this.reload == true) {
      await this.getAuthUser(this.getLoggedUser().id);
    }
  },
  watch: {
    authUser() {
      this.getConnects();
      this.getUserRequests(this.authUser.id);
      this.getNotifications(this.authUser.id);
      this.getSuggestedUsers({
        id: this.authUser.id,
        creator_type: this.authUser.creator_type,
        connects: this.authUser.connects,
      });
      this.getRequestSent(this.authUser.id);
      this.isVerificationRequested(this.authUser.id);
      this.getRequestRecieved(this.authUser.id);
    },
  },
};
</script>
